<template>
  <div class="column align-start part-detail">
    <div class="" style="grid-area: 1 / 1 / 1 / 4"><span>
        <h3>{{ props.title }}</h3>
      </span></div>

    <div class="detail-header" style="grid-area: 2 / 1"><span><b>Part Selection:</b></span></div>
    <div style="grid-area: 2 / 2 / 2 / 7; margin-top:-8px; margin-bottom:8px">
      <DropDownListComponent ref="partDropDown" width="100%" cssClass="slot-dropdown" :dataSource='partDropOptions'
        :fields="{ text: 'display', value: 'id' }" :close="onDropListClose" :created="onDropListCreate"
        v-model:value="selectedPart" />
    </div>

    <div class="detail-header" style="grid-area: 3 / 1"><span><b>Customer Platform:</b></span></div>
    <div class="detail-value" style="grid-area: 3 / 2"><span>{{ currentPart?.CustomerPlatform }}</span></div>
    <div class="detail-header" style="grid-area: 4 / 1"><span><b>ECR Number:</b></span></div>
    <div class="detail-value" style="grid-area: 4 / 2"><span>{{ currentPart?.EcrNumber }}</span></div>
    <div class="detail-header" style="grid-area: 4 / 3"><span><b>Rev:</b></span></div>
    <div class="detail-value" style="grid-area: 4 / 4"><span>{{ currentPart?.Rev }}</span></div>
    <div class="detail-header" style="grid-area: 5 / 1"><span><b>Option:</b></span></div>
    <div class="detail-value" style="grid-area: 5 / 2"><span>{{ currentPart?.Option }}</span></div>
    <div class="detail-header" style="grid-area: 5 / 3"><span><b>Suffix:</b></span></div>
    <div class="detail-value" style="grid-area: 5 / 4"><span>{{ currentPart?.Suffix }}</span></div>
    <div class="detail-header" style="grid-area: 6 / 1"><span><b>Saleable Part Number:</b></span></div>
    <div class="detail-value" style="grid-area: 6 / 2"><span>{{ currentPart?.PartNumber }}</span></div>
    <div class="detail-header" style="grid-area: 7 / 1"><span><b>Saleable Part Name:</b></span></div>
    <div class="detail-value" style="grid-area: 7 / 2 / 7 / 7"><span>{{ currentPart?.PartName }}</span></div>
    <div class="detail-header" style="grid-area: 8 / 1"><span><b>Version:</b></span></div>
    <div class="detail-value" style="grid-area: 8 / 2 / 8 / 7"><span>{{ currentPart?.VersionName }}</span></div>
    <div class="detail-header" style="grid-area: 9 / 1"><span><b>Max Annual Volume:</b></span></div>
    <div class="detail-value" style="grid-area: 9 / 2"><span>{{ maxAnnualVol }}</span></div>
    <div class="detail-header" style="grid-area: 9 / 3"><span><b>Selected Year Volume:</b></span></div>
    <div class="detail-value" style="grid-area: 9 / 4"><span>{{ selectedYearVol }}</span></div>
    <div class="detail-header" style="grid-area: 9 / 5"><span><b>Vol Yr:</b></span></div>
    <div class="" style="grid-area: 9 / 6; margin-top:-8px">
      <DropDownListComponent ref="yearDropDown" width="100%" :dataSource='availYears' v-model:value="year" />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch } from 'vue';
import { DropDownListComponent } from "@syncfusion/ej2-vue-dropdowns";
import { Tooltip } from '@syncfusion/ej2-vue-popups';

const props = defineProps({
  title: String,
  partOptions: Array,
  //part: Object,
  partId: Number,
  slotIndex: Number,
  tabIndex: Number
});

const emit = defineEmits(['yearChange', 'partChange', 'hiddenToggled']);

const year = ref(0);
const availYears = ref([]);
const maxAnnualVol = ref(0);
const selectedYearVol = ref(0);
const selectedPart = ref("");
const partDropDown = ref({});
const yearDropDown = ref();
const currentPart = ref({});
const partDropOptions = ref([]);
const tooltip = ref(Tooltip);

function onDropListClose() {
  tooltip.value.close();
}

function onDropListBeforeRender(args) {
  let listData = partDropDown.value.dataSource;
  for (let i = 0; i < listData.length; i++) {
    if (listData[i].display === args.target.textContent) {
      tooltip.value.content = listData[i].display;
      tooltip.value.dataBind();
      break;
    }
  }
}

function onDropListCreate() {
  tooltip.value = new Tooltip({
    content: 'Loading...',
    target: '.slot-dropdown .e-list-item',
    position: 'BottomCenter',
    beforeRender: onDropListBeforeRender,
    openDelay: 1000
  })
  tooltip.value.appendTo('body');
}


watch(() => props.partId, (current, previous) => {
  if (current === undefined || current === null || current < 0) {
    maxAnnualVol.value = 0;
    selectedYearVol.value = 0;
    availYears.value = [];
    selectedPart.value = ""
    currentPart.value = undefined;
    partDropDown.value.clear();
    yearDropDown.value.clear();
    return;
  }

  if (current !== previous) {
    let part = props.partOptions.find(x => x.PartId == current);
    currentPart.value = part;
    selectedPart.value = current;
    year.value = part.DisplayYear ?? part.FirstVolYear;
    availYears.value = [...new Set(part.ExchangeRates.map(x => x.year))];
    maxAnnualVol.value = Math.max(...part.Volumes.map(x => x.volume));
  }
});


watch(() => props.partOptions, (current) => {

  partDropOptions.value = current.map(x => ({
    display: `${x.EcrNumber} - ${x.VersionName} - ${x.Option} - ${x.getDisplayName()}`,
    id: x.PartId
  }));
});


watch(selectedPart, (current, previous) => {
  if (current === undefined || current === null || current === previous) return;

  let part = props.partOptions.find(x => x.PartId == current);
  if (current != currentPart.value?.PartId) currentPart.value = part;

  setTimeout(() => emit('partChange', part, year.value, props.slotIndex, props.tabIndex), 150);
});


watch(year, (current, previous) => {
  // Update Annual Volume Value
  const yrvol = currentPart.value?.Volumes?.find(x => x.year === current)?.volume ?? 0;
  selectedYearVol.value = yrvol;

  if (current !== previous) {
    const part = props.partOptions.find(x => x.PartId == selectedPart.value);

    setTimeout(() => emit('yearChange', part?.PartId, current, props.slotIndex, props.tabIndex), 150);
  }
});

</script>

<style scoped>
.part-detail {
  display: grid;
  grid-auto-flow: row;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto;
  grid-column-gap: 20px;
  max-width: 850px;
  margin-left: 15px;
  margin-bottom: 15px;
}

.detail-header,
.detail-value {
  margin-bottom: 5px;
  font-size: 14px;
}
</style>